<template>
<div>
  <h2 style="font-size: 18px;margin: 30px 0 20px 30px;">店铺基本信息</h2>
  <el-row>
    <el-col :span="14">
    <!-- 基本信息 -->
    <el-form style="margin-left: 40px">
      <el-form-item label="店铺名称 :" label-width="120px">
        <el-input v-model="ShopName" placeholder="请输入店铺名称，店铺名称最多20个字" maxlength="20" style="width: 60%"/>
      </el-form-item>
      <el-form-item label="店铺介绍 :" label-width="120px">
        <el-input v-model="dpjj" placeholder="请输入店铺简介(最多输入20个字)" maxlength="20" style="width: 60%"/>
      </el-form-item>
      <el-form-item label="店长姓名 :" label-width="120px">
        <el-input v-model="guanlizheName" placeholder="请输入负责人名字" maxlength="10" style="width: 60%"/>
      </el-form-item>
      <el-form-item label="店铺电话 :" label-width="120px">
        <el-input v-model="guanlizhePhone" placeholder="请输入联系电话" maxlength="11" style="width: 60%"/>
      </el-form-item>
      <!-- <el-form-item label="密码：" style="display: flex; width: 360px">
        <el-input v-model="guanlizhePass" placeholder="6-20位数字、字母组合" maxlength="20" style="width: 90%"/>
      </el-form-item> -->
      <!-- <el-form-item label="店铺创客收款人：" label-width="120px">
        <el-input v-model="telPhone" maxlength="11" placeholder="请输入收款人手机号 （收款人手机号必须已登录授权“甄惠装”小程序）" style="width:60%"/>
      </el-form-item> -->
      <el-form-item label="店铺地址 :" label-width="120px" style="width: 60%">
        <el-cascader v-model="chengshi" placeholder="请选择店铺地址" style="width: 100%"
          :options="options" filterable clearable @change="handleChange"/>
      </el-form-item>
      <el-form style="display: flex; width: 60%">
        <el-form-item label-width="120px" style="width: 60%">
          <el-input v-model="searchQuery" @focus="searchFocus" v-show="showaddress" placeholder="请输入详细地址"/>
          <el-input v-model="searchQuery_" id="searchInput" v-show="!showaddress" placeholder="请输入详细地址"/>
          <baidu-map id="map" @ready="onMapReady" :center="{lng: 116.404, lat: 39.915}" :zoom="15"/>
        </el-form-item>
        <el-form-item label-width="120px" style="width: 40%">
          <el-input v-model="houseNumber" placeholder="请输入门牌号" maxlength="50"/>
        </el-form-item>
      </el-form>
      <el-form-item label="营业时间 :" label-width="120px">
        <el-select v-model="OpenBWeek" @change="weekchange()" placeholder style="width: 12%">
          <el-option :label="item.Name" v-for="(item, index) in weekarr" :value="item.Name" :key="index"/>
        </el-select>
        <span style="margin: 0 10px">到</span>
        <el-select v-model="OpenEWeek" @change="weekchange()" placeholder style="width: 13%">
          <el-option :label="item.Name" v-for="(item, index) in weekarr" :value="item.Name" :key="index"/>
        </el-select>
        <el-time-picker v-model="valueDay" @change="changetimevalue" is-range value-format="HH:mm" format="HH:mm" selectableRange
          range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" style="width: 29%"/>
      </el-form-item>
      <!-- <h2 class="administrators">店铺管理员 <span>温馨提示：手机号为登录账号，店铺管理员可登录管理后台进行店铺内容维护。</span></h2> -->
      <el-form-item label="成交数量 :" label-width="120px">
        <el-input v-model="customerOrderCount" placeholder="请输入成交数量" maxlength="6" style="width: 60%"
          onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/>
      </el-form-item>
      <el-form-item label="均单价格(万元) :" label-width="120px">
        <el-input v-model="jundan" placeholder="请输入均单价格·万元" style="width:60%" maxlength="8"
        onkeyup="value=value.replace(/^(\-)*(\d+)\.(\d).*$/,'$1$2.$3')">
        <i slot="suffix" style="margin-right: 10px;">万元</i>
        </el-input>
      </el-form-item>
    </el-form>
    </el-col>
    <el-col :span="10">
    <el-form>
      <el-form-item label="店铺Logo :" label-width="100px" v-if="newBbType == 1">
        <div v-if="ppjcLogo" style="width: 88px;position: relative;">
          <img src="../../assets/img/aicon36.png" @click="ppjcLogo=''" style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
          <el-image :src="ppjcLogo" class="avatar-dpLogo" @click="handleClickItem" :preview-src-list="[ppjcLogo]"/>
        </div>
        <el-upload class="avatar-uploader-dpLogo" action accept=".jpg, .png" v-else
        :show-file-list="false" :before-upload="brandBuildingMaterials">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="color:#888;">建议尺寸：1比1 ，支持的图片格式，jpg、png。</div>
      </el-form-item>
      <el-form-item label="店铺Logo :" label-width="100px" v-if="newBbType == 2">
        <div v-if="zxgsLogo" style="width: 88px;position: relative;">
          <img src="../../assets/img/aicon36.png" @click="zxgsLogo=''" style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
          <el-image :src="zxgsLogo" class="avatar-dpLogo" @click="handleClickItem" :preview-src-list="[zxgsLogo]"/>
        </div>
        <el-upload class="avatar-uploader-dpLogo" action accept=".png, .jpg" v-else
        :show-file-list="false" :before-upload="decorationCompany">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="color:#888;">建议尺寸：1比1 ，支持的图片格式，jpg、png。</div>
      </el-form-item>
      <el-form-item label="展示图片 :" label-width="100px">
        <div style="display:flex;flex-wrap:wrap">
        <div v-for="(item,index) in imgShopArr" :key="index" style="display:inline-block; position: relative;height:80px;">
          <img src="../../assets/img/aicon36.png" @click="deleteimg(index,item)"
          style="position:absolute;right:6px;top:-8px;z-index: 1;width: 20px;"/>
          <el-image :src="item" @click="handleClickItem" :preview-src-list="imgShopArr" fit="cover"
          style="width:80px;height:80px;display:inline-block;margin-right:15px;"/>
        </div>
        <div class="upload" style="display:inline-block;" v-show="imgShopArr.length<5">
          <el-upload v-show="isdisabled" class="avatar-uploader-zstp" style action :show-file-list="false" :before-upload="beforeUploadShopIntroduction">
            <img :src="zstpUrl" v-if="zstpUrl" class="avatar-zstp" style="width:80px;height:80px;"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </div>
        </div>
        <div style="color:#888;">建议尺寸：1200*675，支持的图片格式：jpg、png。</div>
        <canvas id="canvasa" hidden/>
      </el-form-item>
      <el-form-item label="视频(选填) :" label-width="100px">
        <div v-if="videoSrc" class="videoClass">
          <div @click="newSeevideo(videoSrc)" class="previewingVideo">
            <img :src="videoImg" v-if="videoImg">
            <img src="../../assets/img/spfm.png" v-else>
            <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
          </div>
          <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
        </div>
        <el-upload v-else class="avatar-uploader-zstp" action="" accept="video/*" :before-upload="handleFile">
          <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
        <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
      </el-form-item>
    </el-form>
    </el-col>
  </el-row>
  <el-divider></el-divider>
  <h2 class="shopTitle">服务(经营)信息</h2>
  <!-- 品牌建材 -->
  <el-form v-if="newBbType == 1" style="margin: 0 0 50px 40px">
    <el-form-item label="店铺服务：" :rules="[ { required: true} ]" label-width="120px">
      <el-row class="myyxyy">
        <el-col :span="12"><span style="vertical-align: top;">免预约服务：</span></el-col>
        <el-col :span="12"><span style="vertical-align: top;">需预约服务：</span></el-col>
      </el-row>
      <el-row style="width: 80%;">
        <el-col :span="12">
        <div class="upload" style="margin-top: 20px;">
          <div v-for="(service, i) in services" :key="i" class="yyfwClass">
            <div style="border-right: 1px solid #eee;padding-right: 20px;">
                <img v-if="service.imageUrl" :src="service.imageUrl" class="avatar yyfwImg"/>
                <i v-else class="el-icon-plus avatar-uploader-icon" style="width:120px;"></i>
            </div>
            <div class="yyfwInput">
              <el-input :disabled="service.isBuiltIn == 1" v-model="service.name" maxlength="6" placeholder="请输入服务名称" style="width: 126px; font-size: 12px;"/>
            </div>
            <div style="padding-right: 15px;">
              <el-switch v-model="service.isOpen" :active-value="1" :inactive-value="0" active-color="#138cdd" inactive-color="#999999"></el-switch>
            </div>
            <img v-show="service.isBuiltIn != 1" @click="deleteServicesImg(i,service)" src="../../assets/img/aicon36.png" class="chahao"/>
          </div>

          <div class="upload" v-show="services_isdisabled">
            <el-upload :disabled="!services_isdisabled" class="avatar-uploader" style action :show-file-list="false"
            :before-upload="(file)=>beforeAvatarUpload(file,'1')">
              <img style="width:120px;height:82px" v-if="imageUrl2" :src="imageUrl2" class="avatar"/>
              <i v-else class="el-icon-plus yyfwIcon"></i>
            </el-upload>
          </div>
        </div>
        </el-col>
        <el-col :span="12">
        <div class="upload" style="margin-top: 20px;">
          <div v-for="(service, i) in maServices" :key="i" class="yyfwClass">
            <div style="border-right: 1px solid #eee;padding-right: 20px;">
              <img v-if="service.imageUrl" :src="service.imageUrl" class="avatar yyfwImg"/>
              <i v-else class="el-icon-plus avatar-uploader-icon" style="width:120px;"></i>
            </div>
            <div class="yyfwInput">
              <el-input :disabled="service.isBuiltIn == 1" v-model="service.name" maxlength="6" placeholder="请输入服务名称" style="width: 126px; font-size: 12px;"/>
            </div>
            <div style="padding-right: 15px;">
              <el-switch v-model="service.isOpen" :active-value="1" :inactive-value="0" active-color="#138cdd" inactive-color="#999999"></el-switch>
            </div>
            <img v-show="service.isBuiltIn != 1" @click="deleteMaServicesImg(i,service)" src="../../assets/img/aicon36.png" class="chahao"/>
          </div>

          <div class="upload" v-show="maServices_isdisabled">
            <el-upload :disabled="!maServices_isdisabled" class="avatar-uploader" style action :show-file-list="false"
            :before-upload="(file)=>beforeAvatarUpload(file,'2')">
              <img style="width:120px;height:82px" v-if="imageUrl2" :src="imageUrl2" class="avatar"/>
              <i v-else class="el-icon-plus yyfwIcon"></i>
            </el-upload>
          </div>
        </div>
        </el-col>
      </el-row>
      <span style="text-align:center;color:#ff8083;">
        温馨提示：服务上传图片尺寸200*200px      免预约和需预约服务每种最多可新创建6个服务，服务名称不超过6个汉字。
      </span>
    </el-form-item>
    <el-form-item label="主营品类 :" label-width="120px">
      <span class="choice" @click="choiceBrandtype()">选择</span>
      <div v-show="isshowbrandType" style="width: 80%;">
        <span style="color: #F56C6C">已选择：</span>
        <span v-for="(item, index) in brandTypeNamearr" :key="index" style="margin-right: 5px">{{ item }}</span>
      </div>
    </el-form-item>
    <!-- <el-form-item style="display: flex; width: 100%" label="合作模式：">
      <el-select v-model="operatypeid" placeholder style="background: #fff; width: 439px">
        <el-option :label="item.Name" :value="item.Id" v-for="(item, index) in coperation" :key="index"/>
      </el-select>
    </el-form-item>
    <el-form-item label="合作时间：" style="display: flex; width: 100%" v-show="this.operatypeid == 2">
      <el-date-picker v-model="valueTime" style="width: 439px" type="daterange" value-format="yyyy-MM-dd"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changtime"/>
    </el-form-item>
    <el-form-item style="display: flex; width: 100%" label="回款类型：">
      <el-select v-model="SettleTypeId" placeholder style="background: #fff; width: 439px">
        <el-option :label="item.Name" :value="item.Id" v-for="(item, index) in orderarr" :key="index"/>
      </el-select>
    </el-form-item> -->
    <el-form-item label="返佣配置 :" label-width="120px">
      <span :class="ischilick ? 'choice' : 'choice1'" @click="choiceBrand()">选择</span>
      <div class="mainBrand" v-show="isshowbrand">
        <!-- <span style="color: #F56C6C">已选择：</span> -->
        <el-table border :data="brandNamearr_v" style="margin: 0 0 20px 0;"
          :header-cell-style="{ height:'20px', padding:'2px'}">
          <el-table-column label="品牌名称" align="center" property="brandName"/>
          <el-table-column label="特价让利" align="center" property="brandSpecialOfferCommissionRate"
          :width="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1?'100':''">
            <template scope="scope">
              <el-input v-model="scope.row.brandSpecialOfferCommissionRate" maxLength='2' class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/> %
            </template>
          </el-table-column>
          <el-table-column label="普通让利" align="center" property="brandOrdinaryCommissionRate"
          :width="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1?'100':''">
            <template scope="scope">
              <el-input v-model="scope.row.brandOrdinaryCommissionRate" maxLength='2' class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/> %
            </template>
          </el-table-column>
          <el-table-column label="平台 (%)" align="center" property="platformRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.platformRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="消费者 (%)" align="center" property="userRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.userRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="一级共创 (%)" align="center" property="firstCoRate" width="100"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.firstCoRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="二级共创 (%)" align="center" property="secondCoRate" width="100"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.secondCoRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="共创池 (%)" align="center" property="coRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.coRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="合伙人 (%)" align="center" property="partnerRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.partnerRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="导购 (%)" align="center" property="guideRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.guideRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="BD (%)" align="center" property="bdRate"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.bdRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="设计师 (%)" align="center" property="designerRate"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.designerRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
    </el-form-item>
    <!-- <el-form-item label="渠道分佣(选填):" label-width="120px">
      <span class="choice" @click="handleQdfy()">选择</span>
    </el-form-item> -->
  </el-form>
  <!-- 装修公司 -->
  <el-form v-if="newBbType == 2" style="margin-left: 40px">
    <el-form-item label="店铺服务：" :rules="[ { required: true} ]" label-width="120px">
      <div style="color: #999;">1.最多支持4个服务信息，可随时进行调整编辑，随时开启显示或关闭显示。</div>
      <div style="color: #999;margin-top: -10px;">2.参考示例：【免·0元量房，精准报价 】【免·0元搞定全屋设计】【免·0增项整装更放心】【礼·签约豪礼相送】。</div>
      <div style="margin-top: 15px;" v-for="(item,index) in dpfwArr" :key="index">
        <el-input v-model="item.content" maxlength="30" placeholder="请输入内容,最多30个字" class="input-with-select" style="width:580px;">
          <el-select v-model="item.name" slot="prepend" placeholder="请选择" @change="changeActivityForm" style="width: 130px;">
            <el-option v-for="(item, index) in newActivityFormList" :key="index" :value="item.id" :label="item.name"/>
          </el-select>
          <el-switch slot="append" v-model="item.isOpen" active-color="#138cdd" inactive-color="#999999"/>
        </el-input>
      </div>
    </el-form-item>
    <el-form-item label="主营业务：" label-width="120px">
      <div style="color: #999;">( 请根据店铺实际经营情况，勾选主营业务内容，至少选择一项 )</div>
      <el-checkbox-group v-model="checkId" style="height: 50px;">
        <el-checkbox v-for="item in checkList" :label="item.Id" :key="item.Id">{{item.Name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="擅长空间：" label-width="120px">
      <span class="choice" @click="choosekong">选择</span>
      <!-- <div v-show="isshowbrand">
        <span style="color:#F56C6C">已选择：</span>
        <span style="margin-right:5px;" v-for="(item,index) in brandNamearr" :key="index">{{item}}</span>
      </div>-->
      <div style="margin-left:10px" v-show="isshowbrand">
        <span style="color:#F56C6C">已选择：</span>
        <span style="margin-right:5px;" v-for="(item,index) in homenamearr" :key="index">{{item}}</span>
      </div>
    </el-form-item>
    <el-form-item label="返佣配置：" label-width="120px">
      <!-- <span class="choice" @click="choiceRange()">选择</span> -->
      <div class="mainBrand" v-show="constructionList.length>0">
        <!-- <span style="color:#F56C6C">已选择：</span> -->
        <!-- <span style="margin-right:5px;" v-for="(item,index) in constructionList" :key="index">{{item}}</span> -->
        <el-table border :data="constructionList" style="margin: 0 0 20px 0;" :header-cell-style="{ height:'35px', padding:'2px'}">
          <el-table-column label="项目" align="center" property="rangeName" :width="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1?'100':''"/>
          <!-- <el-table-column label="特价让利" align="center" property="brandSpecialOfferCommissionRate">
            <template scope="scope">
              <el-input type="text" class="brandTable" v-model="scope.row.brandSpecialOfferCommissionRate"/> %
            </template>
          </el-table-column> -->
          <el-table-column label="普通让利" align="center" property="brandOrdinaryCommissionRate"
          :width="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1?'100':''">
            <template scope="scope">
              <el-input v-model="scope.row.brandOrdinaryCommissionRate" maxLength='2' class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/> %
            </template>
          </el-table-column>
          <el-table-column label="平台 (%)" align="center" property="platformRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.platformRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="消费者 (%)" align="center" property="userRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.userRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="一级共创 (%)" align="center" property="firstCoRate" width="100"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.firstCoRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="二级共创 (%)" align="center" property="secondCoRate" width="100"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.secondCoRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="共创池 (%)" align="center" property="coRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.coRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="合伙人 (%)" align="center" property="partnerRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.partnerRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="导购 (%)" align="center" property="guideRate" v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.guideRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="BD (%)" align="center" property="bdRate"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.bdRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          <el-table-column label="设计师 (%)" align="center" property="designerRate"
          v-if="isadmin == 1 || isplatformadmin == 1 || iscityadmin == 1">
            <template scope="scope">
              <el-input v-model="scope.row.designerRate" class="brandTable"
              oninput="value=value.replace(/[^\d]/g,'')"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="addGoodsForm.stock = $event.target.value"/>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
    </el-form-item>
  </el-form>
  <div class="gudingdibu">
    <el-button @click="goOneback()">取消</el-button>
    <el-button type="danger" @click="editPreservation()" :loading="loadingBut">{{loadingButText}}</el-button>
  </div>

  <!--点击选择弹框-->
  <el-dialog :title="brandOrType == 0 ? '选择品牌' : '选择品类'" :visible.sync="dialogVisible2"
    :close-on-click-modal="false" :before-close="handleClose2" width="900px">
    <div class="chooseDia">
      <div class="searchRight">
        <div class="searchTop">
          <span @click="chooseLetter2(item, index)" :class="{ changeColor: firstLetterType == index }"
            v-for="(item, index) in letterList" :key="index">{{ item.name }}</span>
          <el-input v-show="brandOrType == 0" v-model="searchConpai" placeholder="请输入搜索内容">
            <template slot="append">
              <el-button @click="findinfo()">搜索</el-button>
            </template>
          </el-input>
          <el-input v-show="brandOrType == 1" v-model="searchConlei" placeholder="请输入搜索内容">
            <template slot="append">
              <el-button @click="findinfo()">搜索</el-button>
            </template>
          </el-input>
          <!-- <p>
            <el-checkbox v-model="checkedAll">不限</el-checkbox>
          </p>-->
        </div>
        <div class="searchBot" :style="typeHide ? 'max-height:155px' : 'max-height:250px'">
          <p class="Brand" style="cursor: pointer" :class="item.checkedBrand == true ? 'brandColor' : ''"
            ref="brandName" v-for="(item, index) in brandList" :key="index" @click="choosedBrand(item, index)">
            {{ item.Name }}
          </p>
          <div v-if="noMore" style="text-align: center; padding-top: 50px"> 不好意思，未搜索到此内容 </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div style="text-align: center">
        <el-button @click="goReturn2()">取消</el-button>
        <el-button type="danger" @click="sureChoose2()">确认</el-button>
      </div>
    </span>
  </el-dialog>

  <!-- 擅长空间 - 弹框 -->
  <el-dialog title="擅长空间" :visible.sync="centerDialogVisible" width="900px" :before-close="handleCloseDialog">
    <div style="height:300px" class="chooseDia">
      <div style="height:300px" class="searchRight">
        <div style="font-size: 18px;margin: 20px 0 0 20px;">家装</div>
        <div class="searchBot">
          <p class="Brand" style="cursor: pointer;" :class="item.checkedBrand==true?'brandColor':''" ref="home"
            v-for="(item,index) in homearr" :key="index" @click="choosehome(item,index)">{{item.Name}}</p>
          <div v-if="noMoreSorry" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
        <div style="font-size: 18px;margin: 20px 0 0 20px;">公装</div>
        <div class="searchBot">
          <p class="Brand" style="cursor: pointer;" :class="item.checkedBrand==true?'brandColor':''" ref="work"
            v-for="(item,index) in workarr" :key="index" @click="choosework(item,index)">{{item.Name}}</p>
          <div v-if="noMoreSorry" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align:center;">
      <el-button @click="nosure2()">取消</el-button>
      <el-button type="danger" @click="yessure2()">确认</el-button>
    </div>
  </el-dialog>

  <!-- 施工方式 - 弹框 -->
  <el-dialog title="施工方式" :visible.sync="constructionMethod" width="900px" :before-close="handleCloseDialog">
    <div style="height:221px" class="chooseDia">
      <div style="height:221px" class="searchRight">
        <div class="searchBot">
          <p style="cursor: pointer;" :class="{brandColor: tmpList.indexOf(item.Id) > -1}" ref="styleName"
            v-for="(item,index) in specialtyStyleList" :key="index" @click="choosedSpecialty(item,index)">{{item.Name}}</p>
          <div v-if="noMoreSorry" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center;">
        <el-button type="danger" @click="yesConstructionSure()">确认</el-button>
        <el-button @click="noConstruction()">取消</el-button>
      </div>
    </span>
  </el-dialog>

  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>

  <!-- 选择渠道企业 -->
  <el-dialog title="选择渠道企业" :visible.sync="dialogVisible" width="680px" height="422px">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true">
          <!-- 顶部搜索框 -->
          <el-form-item>
            <el-input v-model="searchKey" placeholder="请输入关键词" style="width:230px"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="getSortList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="confirmSetRole">确定</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-row class="shut">
      <el-col :span="12"><p>企业名称</p></el-col>
      <el-col :span="12"><p>已选企业</p></el-col>
    </el-row>
    
    <el-row class="shuttle">
      <el-col :span="12"></el-col>
      <div style="width:50%;float:left" class="TLeft">
        <p v-for="(val,index) in TData" @click="checkImg(val,index)" :key="index" v-show="val.rolename.indexOf(tempkey)>-1">
          <img :src="src1" alt v-if="val.ischecked==0" class="left_img" style />
          <img :src="src2" alt v-else class="left_img" />
          <span>{{val.rolename}}</span>
        </p>
      </div>
      <el-col :span="12" class="border_r">
        <div class="TRight" v-for="(item,index) in TData" :key="index" v-show="item.ischecked==1">
          <p>{{item.rolename}}</p>
          <img src="../../assets/img/aicon36.png" alt @click="canCheck(item,index)" class="chahao"/>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</div>
</template>
<script>
import { BMap } from 'vue-baidu-map';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, postAddFile, uploadVedio, provincegetcountys } from '../../api/newOss';
import { getkind, SelectDesignerSkilledDoMainBaseData } from "../../api/api";
import { SelectGoodsBrandTypeByFirstLetter, newGetDcService, newPostBrandBusiness, newPutBrandBusiness, newGetBrandBusiness } from "../../api/attractInvestment";
import { rolegetlist,userroleset, } from "../../api/comment";
export default {
  props: ["isadd"],
  name: "seeFindshop",
  components: {
    BMap
  },
  data() {
    return {
      addOredit: 0,
      ppjc: false,
      zxgs: false,
      huikuanoptions: [],
      coperation: [
        {
          Id: 0,
          Name: "请选择",
        },
        {
          Id: 1,
          Name: "按产品",
        },
        {
          Id: 2,
          Name: "按年",
        },
      ],
      pinliearr: [],
      pinlieId: [],
      pinpaiarr: [],
      pinpaiId: [],
      weekNum1: "",
      weekNum2: "",
      weekTime1: "",
      weekTime2: "",
      isshowbrandType: false,
      isshowbrand: false,
      brandNamearr: [],
      brandNamearr_v: [],
      brandTypeNamearr: [], // 主营品类
      shopinfoextend: "",
      shopinfo: [],
      noMore: "",
      typeHide: "",
      Brandtypearr: [],
      typeIndex: [],
      brandIndex: [],
      ischilick: false,
      Brandarr: [],
      firstChoice: 0,
      brandOrType: 0,
      searchCon: "",
      checkedbiddingId: 0,
      brandList: [],
      checkedAll: false,
      firstLetterType: 0,
      orderId: 1,
      BrandIds: "1",
      BrandTypeIds: "1",
      OpenBWeek: "周一", // 营业时间 - 周开始
      OpenEWeek: " 周六", // 营业时间 - 周结束
      valueDay: ["9:00", "19:00"],
      OpenBDay: "9:00",
      OpenEDay: "19:00",
      operType: 1,
      weekId1: 1,
      weekId2: 7,
      // operatypeid: 0, // 合作模式
      // valueTime: "", // 合作时间
      // SettleTypeId: 1, // 回款类型
      data1: "",
      data2: "",
      huikuanid: "",
      xuanze: [],
      dialogVisible2: false,
      key1: "",
      letterList: [
        { name: "全部" },
        { name: "A-G" },
        { name: "H-N" },
        { name: "O-T" },
        { name: "U-Z" },
      ],
      orderarr: [
        {
          Id: 1,
          Name: "7天结算",
        },
        {
          Id: 2,
          Name: "订单完成时结算",
        },
      ],
      weekarr: [
        {
          Id: 1,
          Name: "周一",
        },
        {
          Id: 2,
          Name: "周二",
        },
        {
          Id: 3,
          Name: "周三",
        },
        {
          Id: 4,
          Name: "周四",
        },
        {
          Id: 5,
          Name: "周五",
        },
        {
          Id: 6,
          Name: "周六",
        },
        {
          Id: 7,
          Name: "周日",
        },
      ],
      ppjcLogo: "", // 品牌建材logo
      ppjcUrl: "", // 品牌建材
      zxgsLogo: "", // 装修公司logo
      zxgsUrl: "", // 装修公司

      ShopName: "", // 店铺名称
      dpjj: '', // 店铺简介
      telPhone: '', // 店铺创客收款人
      customerOrderCount: '', // 成单数量
      jundan: "", // 均单价格
      searchConlei: "",
      searchConpai: "",
      brandListother: [],
      chengshi: "", // 店铺地址
      options: [],
      provinceId: 0,
      cityId: 0,
      cascaderCityName: '', // 城市名称
      zoneId: 0,
      searchQuery: '', // 详细地址
      searchQuery_: '', // 详细地址
      showaddress: true,
      ac: null,
      lng: "", // 经度
      lat: "", // 纬度

      houseNumber: "", // 门牌号
      guanlizheName: '', // 负责人姓名
      guanlizhePhone: '', // 负责人电话
      guanlizhePass: '', // 密码

      // 装修公司
      homearr: [],
      workarr: [],
      ishow: true,
      stylearr: [],
      styleNamearr: [],
      noMoreSorry: false, // 不好意思
      searchCon: "",
      centerDialogVisible: false, // 擅长空间
      constructionMethod: false, // 施工方式
      checked1: false,
      StyleIds: [],
      DomainIds: [],
      homenamearr: [],
      IsAllPrice: 0,
      MinAcceptPrice: "",
      MaxAcceptPrice: "",
      constructionList: [], // 施工方式列表
      tmpList:[], // 施工方式临时存放
      IsInterview: 0,
      MinDesignPrice: "",
      MaxDesignPrice: "",
      Name: "",
      DesId: "",
      form: {},
      isshowbrandType: false,
      isshowbrand: false,
      checked: false,
      brandNamearr: [],
      brandTypeNamearr: [],
      DesInfo: {},
      specialtyStyleList: [], // 擅长空间
      form: {},
      styleNamearr: [],
      zichilder: [],
      workarr: [],
      sunchilder: [],
      sunindex: 0,
      ziindex: 0,
      styleId1: false,
      optionsindex: 0,
      cityId: 0,
      streetId: 0,
      DomainIds1: [],
      homenamearr1: [],
      zonek:'',
      
      imgShopArr: [], // 展示图片
      onePic: [],
      isdisabled: true,
      zstpUrl: '', // 展示图片
      imageUrl2: "", // 店铺服务

      videoImg: '', // 视频封面图
      videoSrc: "", // 全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      services:JSON.parse("[\n" +
          "      {\n" +
          "        \"name\": \"送货服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/送货服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      },\n" +
          "      {\n" +
          "        \"name\": \"安装服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/安装服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      },\n" +
          "      {\n" +
          "        \"name\": \"售后服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/售后服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      }\n" +
          "    ]"),

      maServices:JSON.parse("[\n" +
          "      {\n" +
          "        \"name\": \"量房服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/量房服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      },\n" +
          "      {\n" +
          "        \"name\": \"报价服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/报价服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      },\n" +
          "      {\n" +
          "        \"name\": \"设计服务\",\n" +
          "        \"imageUrl\": \"https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/BrandBusinessServiceImg/Base/设计服务@2x.png\",\n" +
          "        \"isOpen\": 0,\n" +
          "        \"isBuiltIn\": 1\n" +
          "      }\n" +
          "    ]"),
      services_isdisabled : true,
      maServices_isdisabled : true,

      dpfwArr: [
        {
          name: '',
          content: '',
          isOpen: false
        },
        {
          name: '',
          content: '',
          isOpen: false
        },
        {
          name: '',
          content: '',
          isOpen: false
        },
        {
          name: '',
          content: '',
          isOpen: false
        }
      ],
      newActivityFormList: [], // 装修公司服务标识
      checkId: [], // 获取勾选中的值
      checkList: [], // 主营业务
      enterpriseId: '', // 企业id
      newBbType: '', // 企业类型 1=品牌建材、2=装修公司、3=个人设计师
      
      loadingBut: false,
      loadingButText: '确定',
      
      isadmin: localStorage.isadmin, // 是否是超级管理员 0=否 1=是
      isplatformadmin: localStorage.isplatformadmin, // 是否是平台(全国)管理员 0=否 1=是
      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是
      
      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      
      // 角色设置弹窗
      dialogVisible: false,
      searchKey: "",
      tempkey: "",
      alreadyChoose: [],
      TData: [],
      src1: require("../../assets/img/aicon13.png"),
      src2: require("../../assets/img/aicon10.png"),

    };
  },
  methods: {
    // 渠道分佣
    handleQdfy(){
      this.dialogVisible = true;
      this.searchKey='';
      this.alreadyChoose = [];
      let params = {
        userid: 10073, // 用户ID
        roleName: this.searchKey, // 角色名称 模糊匹配 需urlencode一次
      };
      rolegetlist(params).then(res => {
        this.TData = res.resultObj || [];
      })
    },
    // 查询
    getSortList() {
      this.tempkey = this.searchKey;
    },
    // 选中企业
    checkImg(val, index) {
      if (this.TData[index].ischecked) {
        this.TData[index].ischecked = 0;
      } else {
        this.TData[index].ischecked = 1;
      }
    },
    // 取消选中企业
    canCheck(item, index) {
      this.TData[index].ischecked = 0;
    },
    // 确定渠道企业
    confirmSetRole() {
      this.issure = false;
      let tempRoles = [],
      that = this;
      this.TData.forEach(el => {
        if (el.ischecked == 1) {
          tempRoles.push(el.roleid);
        }
      });
      let params = {
        userid: 10073, // 用户ID
        operatorid: localStorage.Id, // 操作人ID
        // roles: tempRoles.join(","), // 角色ID数组
        roles: tempRoles, // 角色ID数组
      };
      userroleset(params).then(data => {
        if (data.resultCode == 1) {
          that.dialogVisible = false;
          this.showAlert('设置成功', 'success');
          that.init();
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    
    },
    // 初始化-获取施工方式
    getsgfs() {
      var obj = {
        tableName: 'tBDBearRange',
        keyWord: this.searchCon,
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          this.specialtyStyleList = data.ResultObj;
          this.tmpList = this.specialtyStyleList.map(item => item.Id);
          this.tmpList.map(i =>{
            let item = this.specialtyStyleList.find(item=>item.Id==i)
            if(this.constructionList.find(ii=>ii.rangeId==item.Id)){}
            else{
              let newData = {
                rangeId: item.Id, // 施工方式id
                rangeName: item.Name, // 施工方式名称
                brandSpecialOfferCommissionRate: 10,
                brandOrdinaryCommissionRate: 20,
                platformRate: 2,
                userRate: 20,
                firstCoRate: 40,
                secondCoRate: 7,
                coRate: 1,
                partnerRate: 6,
                guideRate: 3,
                bdRate: 1,
                designerRate: 20,
              };
              this.constructionList.push(newData);
            }
          })
        }
      });
    },

    // 回显 品牌建材 & 装修公司
    getEchoInfo() {
      var obj = {
          id: localStorage.businessBbId, // 店铺id
      };
      newGetBrandBusiness(obj).then(data => {
        if (data.resultCode == 1) {
          this.shopinfo = data.resultObj;
          this.newBbType = this.shopinfo.bbType; // 店铺类型 1=品牌建材、2=装修公司
          this.ShopName = this.shopinfo.name; // 店铺名称
          this.dpjj = this.shopinfo.introContent; // 店铺简介
          this.guanlizheName = this.shopinfo.contacts; // 负责人姓名
          this.guanlizhePhone = this.shopinfo.phone; // 负责人电话
          // this.guanlizhePass = this.shopinfo.pwd; // 密码
          this.telPhone = this.shopinfo.telPhone; // 店铺创客收款人
          this.chengshi = [ this.shopinfo.provinceId, this.shopinfo.cityId, this.shopinfo.zoneId,]; // 店铺地址
          this.$nextTick(() => {
            // 获取选中的省份
            const selectedProvince = this.options.find(option => option.value === this.shopinfo.provinceId);
            // 获取选中的城市
            const selectedCity = selectedProvince.children.find(child => child.value === this.shopinfo.cityId);
            // 设置选中的城市名称
            this.cascaderCityName = selectedCity.label;
          });
          
          this.searchQuery = this.shopinfo.address; // 详细地址
          this.lng = this.shopinfo.lng; // 经度
          this.lat = this.shopinfo.lat; // 纬度
          this.houseNumber = this.shopinfo.houseNumber; // 门牌号
          this.OpenBWeek = this.shopinfo.openBWeek ? this.shopinfo.openBWeek : "周一"; // 营业时间 - 周开始
          this.OpenEWeek = this.shopinfo.openEWeek ? this.shopinfo.openEWeek : "周六"; // 营业时间 - 周结束
          this.valueDay = [this.shopinfo.openBDay?this.shopinfo.openBDay:'', this.shopinfo.openEDay?this.shopinfo.openEDay:'']; // 营业时间 - 天开始&天结束
          this.OpenBDay = this.shopinfo.openBDay;
          this.OpenEDay = this.shopinfo.openEDay;
          this.customerOrderCount = this.shopinfo.customerOrderCount; // 成交数量
          this.jundan = this.shopinfo.customerOrderAvgPrice; // 均单价格
          // 店铺Logo
          if (this.shopinfo.logoUrl + "" == "null") {
            this.ppjcLogo = "";
            this.ppjcUrl = "";
          } else {
            if(this.newBbType == 1) {
              this.ppjcLogo = localStorage.BaseOssUrl + this.shopinfo.logoUrl; // 回显 - 品牌建材: 拼接长链接
              this.ppjcUrl = this.shopinfo.logoUrl; // 回显 - 品牌建材: 短连接
            } else {
              this.zxgsLogo = localStorage.BaseOssUrl + this.shopinfo.logoUrl; // 回显 - 装修公司: 拼接长链接
              this.zxgsUrl = this.shopinfo.logoUrl; // 回显 - 装修公司: 短连接
            }
          }
          this.imgShopArr = this.shopinfo.imgs.map(item => item.replace('', localStorage.BaseOssUrl)); // 展示图片集合
          this.videoSrc = this.shopinfo.videoUrl?localStorage.BaseOssUrl + this.shopinfo.videoUrl:''; // 视频-长
          this.videoShortSrc = this.shopinfo.videoUrl?this.shopinfo.videoUrl:''; // 视频-短

          if(this.newBbType == 1) {
            this.isshowbrandType = true; // 主营品类
            this.brandTypeNamearr = this.shopinfo.brandTypeNames.split(",");
            this.pinliearr = this.brandTypeNamearr;
            this.Brandtypearr = [];
            this.Brandtypearr = this.shopinfo.brandTypeIds.split(",");
            this.Brandtypearr = this.shopinfo.brandTypeIds.split(",").sort((a, b) => {
              return a - b;
            });
            if (this.Brandtypearr.length == 0) {
              this.ischilick = false;
            } else {
              this.ischilick = true;
            }
            this.pinlieId = this.Brandtypearr;

            this.isshowbrand = true; // 主营品牌
            let that = this;
            that.brandNamearr_v = that.shopinfo.brands; // 品牌列表回显
            that.brandNamearr = that.brandNamearr_v.map((b) => b.brandName);
            that.pinpaiarr = that.brandNamearr;

            that.Brandarr = that.brandNamearr_v.map((b) => b.brandId);
            that.pinpaiId = that.Brandarr;
            
            that.services = that.shopinfo.services;
            that.maServices = that.shopinfo.maServices;
            
          } else {
            this.dpfwArr = this.shopinfo.dcService; // 装修公司-店铺服务
            this.checkId = this.shopinfo.mainBusiness; // 装修公司-主营业务
            // 擅长空间
            this.DomainIds = [];
            this.homenamearr = [];
            this.DomainIds1 = [];
            this.homenamearr1 = [];
            this.isshowbrand = true;
            this.shopinfo.domains.map(item => {
              this.DomainIds.push(item.id);
              this.DomainIds1.push(item.id);
              this.homenamearr.push(item.name);
              this.homenamearr1.push(item.name);
            })
            this.constructionList = this.shopinfo.ranges; // 施工方式回显
          }
          
          
          // this.operatypeid = this.shopinfo.cooperationTypeId; // 合作模式
          // if(this.operatypeid == 2) {
          //   this.valueTime = [this.shopinfo.coStarTime?this.shopinfo.coStarTime:'', this.shopinfo.coEndTime?this.shopinfo.coEndTime:'']; // 合作时间
          // }
          // this.data1 = this.shopinfo.coStarTime; // 合作开始时间
          // this.data2 = this.shopinfo.coEndTime // 合作结束时间
          // this.SettleTypeId = this.shopinfo.settleTypeId ? this.shopinfo.settleTypeId : 1; // 回款类型

        }
      });
    },
    
    // 保存
    editPreservation() {
      if (this.ShopName == "") {
        this.$swal({
          type: "warning",
          text: "请输入店铺名称",
        });
        return false;
      }
      if (!this.dpjj) {
        this.$swal({
          type: "warning",
          text: "请输入店铺简介",
        });
        return false;
      }
      if (this.guanlizheName == "") {
        this.$swal({
          type: "warning",
          text: "请输入负责人姓名",
        });
        return false;
      }
      if (this.guanlizhePhone == "") {
        this.$swal({
          type: "warning",
          text: "请输入负责人电话",
        });
        return false;
      }
      // if (this.telPhone == "") {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入店铺创客收款人",
      //   });
      //   return false;
      // }
      if (this.chengshi == "") {
        this.$swal({
          type: "warning",
          text: "请选择店铺地址",
        });
        return false;
      }
      if (this.searchQuery == "") {
        this.$swal({
          type: "warning",
          text: "请输入详细地址",
        });
        return false;
      }
      if (this.houseNumber == "") {
        this.$swal({
          type: "warning",
          text: "请输入门牌号",
        });
        return false;
      }
      // if (this.customerOrderCount == "") {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入成交数量",
      //   });
      //   return false;
      // }
      // if (this.jundan == "") {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入均单价格",
      //   });
      //   return false;
      // }
      if (this.newBbType == 1 && this.ppjcLogo == "") {
        this.$swal({
          type: "warning",
          text: "请上传 品牌建材 店铺logo",
        });
        return false;
      }
      if (this.newBbType == 2 && this.zxgsLogo == "") {
        this.$swal({
          text: "请上传 装修公司 店铺logo",
          type: "warning"
        });
        return false;
      }
      if(this.imgShopArr.length == 0){
        this.$swal({
          type:'warning',
          text: '请至少上传一张展示图片',
        })
        return false;
      }
      // if (this.guanlizhePass == "") {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入密码",
      //   });
      //   return false;
      // }
      if(this.newBbType == 1) {
        if (this.brandTypeNamearr.length == 0) {
          this.$swal({
            type: "warning",
            text: "请选择主营品类",
          });
          return false;
        }
        if (this.brandNamearr_v.length == 0) {
          this.$swal({
            type: "warning",
            text: "请选择返佣配置",
          });
          return false;
        }
        // if (this.brandNamearr_v.length > 0 && this.brandNamearr_v.find(item => !item.brandSpecialOfferCommissionRate)) {
        //   this.$swal({
        //     type: "warning",
        //     text: "请输入特价让利",
        //   });
        //   return false;
        // }
        if(this.brandNamearr_v.find(item => item.brandSpecialOfferCommissionRate>30)) {
          this.$swal({
            type: "warning",
            text: "输入特价让利不能大于30%",
          });
          return false;
        }
        // if (this.brandNamearr_v.length > 0 && this.brandNamearr_v.find(item => !item.brandOrdinaryCommissionRate)) {
        //   this.$swal({
        //     type: "warning",
        //     text: "请输入普通让利",
        //   });
        //   return false;
        // }
        if(this.brandNamearr_v.find(item => item.brandOrdinaryCommissionRate>30)) {
          this.$swal({
            type: "warning",
            text: "输入普通让利不能大于30%",
          });
          return false;
        }
        // if (this.newUserType == 5 && this.brandNamearr_v.find(item => 
        //   Number(item.platformRate) + Number(item.userRate) + Number(item.firstCoRate) + Number(item.secondCoRate) +
        //   Number(item.coRate) + Number(item.partnerRate) + Number(item.guideRate) + Number(item.bdRate) + Number(item.designerRate) != 100)) {
        //   this.$swal({
        //     type: "warning",
        //     text: "佣金比例相加必须等于100",
        //   });
        //   return false;
        // }
        // if (this.operatypeid == 0) {
        //   this.$swal({
        //     type: "warning",
        //     text: "请选择合作模式",
        //   });
        //   return false;
        // }
        // if ( this.operatypeid == 2 && (this.data1 == "" || this.data2 == "")){
        //   this.$swal({
        //     type: "warning",
        //     text: "请选择合作时间",
        //   });
        //   return false;
        // }
      }
      if(this.newBbType == 2) {
        for (let item of this.dpfwArr) {
          if(item.isOpen){
            if (!item.name || item.content === '') {
              this.$swal({
                text: "店铺服务中已开启的服务项，请选择服务类型并填写文案内容。",
                type: "warning"
              });
              return false;
            }
          }
        }
        if (this.DomainIds.length == 0) {
          this.$swal({
            text: "请选择擅长空间",
            type: "warning"
          });
          return false;
        }
        if (this.constructionList.length == 0) {
          this.$swal({
            text: "请选择施工方式",
            type: "warning"
          });
          return false;
        }
        if(this.constructionList.find(item => item.brandOrdinaryCommissionRate>30)) {
          this.$swal({
            type: "warning",
            text: "输入普通让利不能大于30%",
          });
          return false;
        }
      }
      
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      
      // 添加店铺
      if (this.$route.query.type == 0) {
        var _services = [];
        for(var i =0; i<this.services.length; i++){
          var obj=new Object();

          obj.imageUrl = this.services[i].imageUrl.replace( localStorage.BaseOssUrl, '' );
          obj.name = this.services[i].name;
          obj.isOpen = this.services[i].isOpen;
          obj.isBuiltIn = this.services[i].isBuiltIn;
          _services.push(obj);
        }
        var _maService = [];
        for(var j =0; j<this.maServices.length; j++){
          var obj=new Object();
          obj.imageUrl = this.maServices[j].imageUrl.replace( localStorage.BaseOssUrl, '' );
          obj.name = this.maServices[j].name;
          obj.isOpen = this.maServices[j].isOpen;
          obj.isBuiltIn = this.maServices[j].isBuiltIn;
          _maService.push(obj);
        }
        var loginParams = {
          userId: localStorage.Id, // 操作人id
          // bbType: this.newBbType, // 店铺类型  1=品牌建材、2=装修公司
          name: this.ShopName, // 店铺名称
          introContent: this.dpjj, // 店铺简介
          contacts: this.guanlizheName, // 负责人姓名
          phone: this.guanlizhePhone, // 负责人电话
          // pwd: this.guanlizhePass, // 密码
          telPhone: this.telPhone, // 店铺创客收款人
          provinceId: this.chengshi[0], // 所属省份id
          cityId: this.chengshi[1], // 所属城市id
          zoneId: this.chengshi[2], // 所属区域id
          address: this.searchQuery, // 详细地址
          lng: this.lng, // 经度
          lat: this.lat, // 纬度
          houseNumber: this.houseNumber, // 门牌号
          openBWeek: this.OpenBWeek, // 营业时间每周开始周（周一）
          openEWeek: this.OpenEWeek, // 营业时间每周结束周（周日）
          openBDay: this.OpenBDay, // 营业时间每天开始时间，格式：hh:mm
          openEDay: this.OpenEDay, // 营业时间每天结束时间，格式：hh:mm
          customerOrderCount: this.customerOrderCount?this.customerOrderCount:0, // 成单数量
          customerOrderAvgPrice: this.jundan?this.jundan:0, // 均单价格
          logoUrl: this.newBbType == 1 ? this.ppjcUrl : this.zxgsUrl, // 店铺LOGO路径: 品牌建材 & 装修公司
          imgs: this.imgShopArr.map(item => item.replace(localStorage.BaseOssUrl, '')), // 展示图片集合
          videoUrl: this.videoShortSrc, // 视频（不要前缀）

          service : _services,
          maService: _maService,
          dcService: this.dpfwArr, // 装修公司服务集合
          mainBusiness: this.checkId, // 主营业务集合
          
          brandTypeIds: this.newBbType == 1 ? this.Brandtypearr.join(",") : '', // 主营品类id
          brands: this.newBbType == 1 ? this.brandNamearr_v : [], // 主营品牌

          domainIdsStr: this.newBbType == 2 ? this.DomainIds.join(",") : '', // 擅长空间
          ranges: this.newBbType == 2 ? this.constructionList : [], // 返佣配置

        };
        newPostBrandBusiness(loginParams).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              text:"添加成功",
              type: "success"
            })
            this.$router.go(-1);
            this.loadingBut = false;
            this.loadingButText = '确定';
            
          } else {
            this.loadingBut = false;
            this.loadingButText = '确定';
          }
        })
      }
      // 编辑店铺
      if (this.$route.query.type == 1) {
        var _services = [];
        for(var i =0; i<this.services.length; i++){
          var obj=new Object();

          obj.imageUrl = this.services[i].imageUrl.replace( localStorage.BaseOssUrl, '' );
          obj.name = this.services[i].name;
          obj.isOpen = this.services[i].isOpen;
          obj.isBuiltIn = this.services[i].isBuiltIn;
          _services.push(obj);
        }
        var _maService = [];
        for(var j =0; j<this.maServices.length; j++){
          var obj=new Object();
          obj.imageUrl = this.maServices[j].imageUrl.replace( localStorage.BaseOssUrl, '' );
          obj.name = this.maServices[j].name;
          obj.isOpen = this.maServices[j].isOpen;
          obj.isBuiltIn = this.maServices[j].isBuiltIn;
          _maService.push(obj);
        }
        let obj = {
          userId: localStorage.Id, // 操作人id
          id: localStorage.businessBbId, // 店铺id
          // cooperationTypeId: this.operatypeid, // 合作模式id
          // CoStarTime: this.operatypeid == 2 ? this.data1 : "", // 合作开始时间
          // CoEndTime: this.operatypeid == 2 ? this.data2 : "", // 合作结束时间
          // settleTypeId: this.SettleTypeId, // 回款类型id
          name: this.ShopName, // 店铺名称
          introContent: this.dpjj, // 店铺简介
          contacts: this.guanlizheName, // 负责人姓名
          phone: this.guanlizhePhone, // 负责人电话
          // pwd: this.guanlizhePass, // 密码
          telPhone: this.telPhone, // 店铺创客收款人
          provinceId: this.chengshi[0], // 所属省份id
          cityId: this.chengshi[1], // 所属城市id
          zoneId: this.chengshi[2], // 所属区域id
          address: this.searchQuery, // 详细地址
          lng: this.lng, // 经度
          lat: this.lat, // 纬度
          houseNumber: this.houseNumber, // 门牌号
          openBWeek: this.OpenBWeek, // 营业时间每周开始周（周一）
          openEWeek: this.OpenEWeek, // 营业时间每周结束周（周日）
          openBDay: this.OpenBDay, // 营业时间每天开始时间，格式：hh:mm
          openEDay: this.OpenEDay, // 营业时间每天结束时间，格式：hh:mm
          customerOrderCount: this.customerOrderCount?this.customerOrderCount:0, // 成单数量
          customerOrderAvgPrice: this.jundan?this.jundan:0, // 均单价格
          logoUrl: this.newBbType == 1 ? this.ppjcUrl : this.zxgsUrl, // 店铺LOGO路径: 品牌建材 & 装修公司
          imgs: this.imgShopArr.map(item => item.replace(localStorage.BaseOssUrl, '')), // 展示图片集合
          videoUrl: this.videoShortSrc, // 视频（不要前缀）

          service : _services,
          maService: _maService,
          dcService: this.dpfwArr, // 装修公司服务集合
          mainBusiness: this.checkId, // 主营业务集合
          
          brandTypeIds: this.newBbType == 1 ? this.Brandtypearr.join(",") : '', // 主营品类id
          brands: this.newBbType == 1 ? this.brandNamearr_v : [], // 主营品牌

          domainIdsStr: this.newBbType == 2 ? this.DomainIds.join(",") : '', // 擅长空间
          ranges: this.newBbType == 2 ? this.constructionList : [], // 返佣配置
          
        };
        newPutBrandBusiness(obj).then((data) => {
          if (data.resultCode == 1) {
            localStorage.businessBbId = data.resultMsg;
            this.$swal({
              type: "success",
              text: "保存成功",
            });
            this.$router.go(-1);
            this.loadingBut = false;
            this.loadingButText = '确定';
            
          } else {
            this.loadingBut = false;
            this.loadingButText = '确定';
          }
        });
      }
    },
    // 获取店铺服务4项下拉Name
    changeActivityForm(val){
      // this.newActivityFormList.filter((item,index) => {
      //   if(item.Id == val){
      //     this.typeName = item.Name;
      //   }
      // })
    },
    // 营业时间
    weekchange() {
      for (var i = 0; i < this.weekarr.length; i++) {
        if (this.weekarr[i].Name == this.OpenEWeek) {
          this.weekNum1 = i;
        }
      }
      for (var k = 0; k < this.weekarr.length; k++) {
        if (this.weekarr[k].Name == this.OpenBWeek) {
          this.weekNum2 = k;
        }
      }
      if (this.weekNum1 < this.weekNum2) {
        this.$swal({
          type: "warning",
          text: "选择营业周期结束时需大于开始日期",
        });
        this.OpenEWeek = "";
      }
    },
    // 天时间
    changetimevalue() {
      this.OpenBDay = this.valueDay[0];
      this.OpenEDay = this.valueDay[1];
    },
    // 合作时间
    changtime(val) {
      if (val == null) {
        this.data1 = "";
        this.data2 = "";
      } else {
        this.data1 = val[0];
        this.data2 = val[1];
      }
    },
    // 店铺地址
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2];
      // 获取选中的省份
      const selectedProvince = this.options.find(option => option.value === this.provinceId);
      // 获取选中的城市
      const selectedCity = selectedProvince.children.find(child => child.value === this.cityId);
      // 设置选中的城市名称
      this.cascaderCityName = selectedCity.label;
      this.searchFocus('',1); // 触发搜索框的聚焦事件
    },
    // 查找省+市+区
    getProvincialAndUrbanAreas() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          let provinceData = { value: item.pid, label: item.pname, children: [] };
          provinceAndCityAndarea.push(provinceData);
          item.citys.forEach(city => {
            let cityData = { value: city.cid, label: city.cname, children: [] };
            provinceData.children.push(cityData);
            city.countys.forEach(zone => {
              cityData.children.push({ value: zone.scid, label: zone.scname });
            });
          });
        });
        that.options = provinceAndCityAndarea;
      });
    },
    searchFocus(val, type){
      // 切换城市 清空详细地址
      // if(type == 1){
      //   this.searchQuery = '';
      // }
      if(!this.ac){
        this.ac = new this.BMap.Autocomplete({
          input: 'searchInput',
          location: this.cascaderCityName, // 选中的城市名称
        });
        this.ac.addEventListener('onconfirm', this.onGetSuggestionResult);
      }else{
        // 更新 Autocomplete 的 location 属性
        this.ac.setLocation(this.cascaderCityName);
      }
      // 延迟切换 v-show 状态
      setTimeout(() => {
        this.searchQuery_ = this.searchQuery;
        this.showaddress = false;
        this.$nextTick(() => {
          // DOM更新完成后执行操作
          document.getElementById('searchInput').focus();
          document.getElementById('searchInput').click();
        });
      }, 1);
    },
    // 地图初始化
    onMapReady({BMap, bm}) {
      this.BMap = BMap;
      this.bm = bm;
      
      // 如果已经有选中的区县，则设置地图中心到该区县的中心
      // if (this.zoneId) {
      //   this.getCenterByZoneId(this.zoneId).then(center => {
      //     this.bm.center = center;
      //   }).catch(error => {
      //     console.error('无法获取区县中心位置:', error);
      //   });
      // }

    },
    onGetSuggestionResult(e) {
      this.searchQuery = e.item.value.business; // 详细地址
      console.log('选中地址名称：', this.searchQuery);
      this.searchQuery_ = e.item.value.city + e.item.value.district + e.item.value.business; // 详细地址
      this.showaddress = true
      new window.BMap.Geocoder().getPoint(this.searchQuery_, (point) => {
        console.log('百度地图经度：', point.lng);
        console.log('百度地图纬度：', point.lat);
        // this.lng = point.lng;
        // this.lat = point.lat;
        
        // 调用转换函数
        const thisGaoDe = this.BMapTransTxMap(point.lng, point.lat);
        this.lng = thisGaoDe[0];
        this.lat = thisGaoDe[1];
        console.log('高德地图经度：', this.lng);
        console.log('高德地图纬度：', this.lat);
      });
    },
    // 定义坐标转换函数
    BMapTransTxMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0; // π * 3000 / 180
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats];
    },
    // 搜索
    findinfo() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: this.brandOrType,
        key: this.brandOrType == 0 ? this.searchConpai : this.searchConlei,
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId,
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.brandName.length; i++) {
              this.$refs.brandName[i].style.color = "#606266";
              this.$refs.brandName[i].style.background = "#f0f0f0";
            }
          });
          if (this.brandOrType == 0) {
            this.$nextTick(() => {
              var arr = [];
              var arrId = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandarr.length; k++) {
                  if (this.brandList[i].Id == this.Brandarr[k]) {
                    //   this.Brandarr.push(String(this.brandList[i].Id));
                    // this.brandNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    //  this.Brandarr.push(this.brandList[i].Id);
                  }
                }
              }
            });
          }
          if (this.brandOrType == 1) {
            this.$nextTick(() => {
              var arr1 = [];
              var arrId1 = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandtypearr.length; k++) {
                  if (this.brandList[i].Id == this.Brandtypearr[k]) {
                    //         this.Brandtypearr.push(String(this.brandList[i].Id));
                    // this.brandTypeNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    arr1.push(this.brandList[i].Name);
                    arrId1.push(String(this.brandList[i].Id));
                  }
                }
              }
              // if( this.firstLetterType == 0){
              //  this.Brandtypearr=arrId1
              //   this.brandTypeNamearr = arr1
              // }
            });
          }
        }
      });
    },
    // 选择
    chooseLetter2(item, index) {
      this.checkedOther = false;
      this.searchCon = "";
      this.firstLetterType = index;
      this.letterDia();
    },
    // 品牌品类弹框
    handleClose2() {
      this.dialogVisible2 = false;
    },
    // 品牌品类
    letterDia() {
      var obj = {
        userId: 0,
        firstLetterType: this.firstLetterType,
        brandOrType: this.brandOrType,
        key: this.searchCon,
        brandIdOrGoodsBrandTypeId: this.checkedbiddingId,
      };
      SelectGoodsBrandTypeByFirstLetter(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.brandName.length; i++) {
              this.$refs.brandName[i].style.color = "#606266";
              this.$refs.brandName[i].style.background = "#f0f0f0";
            }
          });
          if (this.brandOrType == 0) {
            if (this.firstLetterType == 0) {
              this.brandListother = this.brandList;
            }
            this.$nextTick(() => {
              var arr = [];
              var arrId = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandarr.length; k++) {
                  if (this.brandList[i].Id == this.Brandarr[k]) {
                    //   this.Brandarr.push(String(this.brandList[i].Id));
                    // this.brandNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    //  this.Brandarr.push(this.brandList[i].Id);
                    arr.push(this.brandList[i].Name);
                    arrId.push(String(this.brandList[i].Id));
                  }
                }
              }
              if (this.firstLetterType == 0) {
                this.brandNamearr = arr;
                this.Brandarr = arrId;
              }
            });
          }
          if (this.brandOrType == 1) {
            this.$nextTick(() => {
              var arr1 = [];
              var arrId1 = [];
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.Brandtypearr.length; k++) {
                  if (this.brandList[i].Id == this.Brandtypearr[k]) {
                    //         this.Brandtypearr.push(String(this.brandList[i].Id));
                    // this.brandTypeNamearr.push(this.brandList[i].Name)
                    this.$refs.brandName[i].style.color = "#fff";
                    this.$refs.brandName[i].style.background = "#F56C6C";
                    arr1.push(this.brandList[i].Name);
                    arrId1.push(String(this.brandList[i].Id));
                  }
                }
              }
              if (this.firstLetterType == 0) {
                this.Brandtypearr = arrId1;
                this.brandTypeNamearr = arr1;
              }
            });
          }
        }
      });
    },
    // 点击品牌品类
    choosedBrand(item, index) {
      if (this.brandOrType == 0) {
        if (this.Brandarr.indexOf(String(item.Id)) > -1) {
          this.Brandarr.splice(this.Brandarr.indexOf(String(item.Id)), 1);
          this.brandIndex.splice(this.brandIndex.indexOf(index), 1);
          this.brandNamearr.splice(this.brandNamearr.indexOf(item.Name), 1);
          // this.brandOrType =1
          // this.letterDia()
          if (this.brandNamearr.length > 0) {
            this.isshowbrand = true;
          } else {
            this.isshowbrand = false;
          }
          this.$refs.brandName[index].style.color = "#606266";
          this.$refs.brandName[index].style.background = "#f0f0f0";
          this.$set(item, "checkedBrand", false);
        } else {
          this.Brandarr.push(String(item.Id));
          this.brandNamearr.push(item.Name);
          if (this.brandNamearr.length > 0) {
            this.isshowbrand = true;
          } else {
            this.isshowbrand = false;
          }
          this.brandIndex.push(index);
          this.$refs.brandName[index].style.color = "#fff";
          this.$refs.brandName[index].style.background = "#F56C6C";
        }
      } else {
        if (this.Brandtypearr.indexOf(String(item.Id)) > -1) {
          this.Brandtypearr.splice(
            this.Brandtypearr.indexOf(String(item.Id)),
            1
          );
          this.brandTypeNamearr.splice(
            this.brandTypeNamearr.indexOf(item.Name),
            1
          );
          if (this.brandTypeNamearr.length > 0) {
            this.isshowbrandType = true;
            this.ischilick = true;
          } else {
            this.isshowbrandType = false;
            this.ischilick = false;
          }
          this.typeIndex.splice(this.typeIndex.indexOf(index), 1);
          this.$refs.brandName[index].style.color = "#606266";
          this.$refs.brandName[index].style.background = "#f0f0f0";
          this.$set(item, "checkedBrand", false);
        } else {
          this.Brandtypearr.push(String(item.Id));
          this.typeIndex.push(index);
          this.brandTypeNamearr.push(item.Name);
          if (this.brandTypeNamearr.length > 0) {
            this.isshowbrandType = true;
            this.ischilick = true;
          } else {
            this.isshowbrandType = false;
            this.ischilick = false;
          }
          this.$refs.brandName[index].style.color = "#fff";
          this.$refs.brandName[index].style.background = "#F56C6C";
        }
      }
    },
    // 选择品类
    choiceBrandtype() {
      if (this.firstChoice == 0 || this.firstChoice == 2) {
        this.firstChoice = 2;
        this.checkedbiddingId = 0;
      }
      if (this.firstChoice == 1) {
        this.checkedbiddingId = 0;
      }
      this.brandOrType = 1;
      this.dialogVisible2 = true;
      this.letterDia();
    },
    // 选择品牌
    choiceBrand() {
      if (this.brandTypeNamearr.length == 0) {
        this.ischilick = false;
        return false;
      }
      this.ischilick = true;
      if (this.firstChoice == 0 || this.firstChoice == 1) {
        this.firstChoice = 1;
        this.checkedbiddingId = this.Brandtypearr.join(",");
      }
      if (this.firstChoice == 2) {
        this.checkedbiddingId = this.Brandtypearr.join(",");
      }
      this.brandOrType = 0;
      this.dialogVisible2 = true;
      this.letterDia();
    },
    // 取消弹框
    goReturn2() {
      this.dialogVisible2 = false;
      if (this.brandOrType == 1) {
        this.Brandtypearr = this.pinlieId;
        this.brandTypeNamearr = this.pinliearr;
        if (this.brandTypeNamearr.length == 0) {
          this.isshowbrandType = false;
        } else {
          this.isshowbrandType = true;
        }
      } else {
        this.Brandarr = this.pinpaiId;
        this.brandNamearr = this.pinpaiarr;
        if (this.brandNamearr.length == 0) {
          this.isshowbrand = false;
        } else {
          this.isshowbrand = true;
        }
      }
    },
    // 确认 - 品类品牌
    sureChoose2() {
      this.dialogVisible2 = false;
      this.pinlieId = this.Brandtypearr;
      this.pinpaiarr = this.brandNamearr;
      this.pinpaiId = this.Brandarr;
      this.pinliearr = this.brandTypeNamearr;
      this.searchConpai = "";
      this.searchConlei = "";
      if (this.brandOrType == 0) {
        this.checkedbiddingId = this.Brandtypearr.join(",");
        this.brandOrType = 0;
        var obj = {
          userId: 0,
          firstLetterType: 0,
          brandOrType: this.brandOrType,
          key: this.searchCon,
          brandIdOrGoodsBrandTypeId: this.checkedbiddingId,
        };
        SelectGoodsBrandTypeByFirstLetter(obj).then((data) => {
          if (data.ResultCode == 1) {
            this.brandList = data.ResultObj;
            this.$nextTick(() => {
              for (var i = 0; i < this.$refs.brandName.length; i++) {
                //  this.$refs.brandName[i].style.color = "#606266";
                // this.$refs.brandName[i].style.background = "#f0f0f0";
              }
            });
            if (this.brandOrType == 0) {
              this.$nextTick(() => {
                var arr = [];
                var arrId = [];
                for (var i = 0; i < this.brandList.length; i++) {
                  for (var k = 0; k < this.Brandarr.length; k++) {
                    if (this.brandList[i].Id == this.Brandarr[k]) {
                      //   this.Brandarr.push(String(this.brandList[i].Id));
                      // this.brandNamearr.push(this.brandList[i].Name)
                      // this.$refs.brandName[i].style.color = "#fff";
                      // this.$refs.brandName[i].style.background = "#F56C6C";
                      //  this.Brandarr.push(this.brandList[i].Id);
                      arr.push(this.brandList[i].Name);
                      arrId.push(String(this.brandList[i].Id));
                      if (this.brandTypeNamearr.length == 0) {
                        arr = [];
                        arrId = [];
                        this.isshowbrand = false;
                      }
                    }
                  }
                }
                this.brandNamearr = arr;
                this.Brandarr = arrId;
              });
            }
          }
        });
      } else {
        let arr = this.brandListother.filter((v) =>
          this.brandNamearr.find((v2) => v2 == v.Name)
        );
        this.brandNamearr = arr.map((v) => v.Name);
      }
      // "BrandId": "品牌id",
      // "BrandName": "品牌名称",
      // "BrandSpecialOfferCommissionRate": "特价让利",
      // "BrandOrdinaryCommissionRate": "普通让利",
      // this.brandNamearr_v = [];
      
      // 根据品牌名称匹配
      // this.brandNamearr_v = this.brandNamearr_v.filter((brand) => {
      //   return this.brandNamearr.find((item) => item == brand.brandName);
      // });
      // this.brandNamearr.filter((item) => {
      //   return this.brandNamearr_v.find((b) => b.brandName == item) ? false : true;
      // }).map((item) => {
      //   let the = this.brandList.find((brand) => brand.Name == item);
      //   let data = {
      //     brandId: the.Id,
      //     brandName: item,
      //     brandSpecialOfferCommissionRate: 0,
      //     brandOrdinaryCommissionRate: 0,
      //   };
      //   this.brandNamearr_v.push(data);
      // });
      
      // 根据品牌id匹配
      this.brandNamearr_v = this.brandNamearr_v.filter(brand => {
        return this.Brandarr.find(item => item == brand.brandId);
      });
      this.Brandarr.filter(item => {
        return this.brandNamearr_v.find(b => b.brandId == item) ? false : true;
      }).map(item => {
        let the = this.brandList.find(brand => brand.Id == item);
        let data = {
          brandId: item,
          brandName: the.Name,
          brandSpecialOfferCommissionRate: 10,
          brandOrdinaryCommissionRate: 20,
          platformRate: 2,
          userRate: 20,
          firstCoRate: 40,
          secondCoRate: 7,
          coRate: 1,
          partnerRate: 6,
          guideRate: 3,
          bdRate: 1,
          designerRate: 20,
        };
        this.brandNamearr_v.push(data);
      });
      
    },
    // 点击
    choosedSpecialty(item, index) {
      if (this.tmpList.indexOf(item.Id) > -1) { // 取消选中
        this.tmpList.splice(this.tmpList.indexOf(item.Id), 1);
      } else { // 选中
        this.tmpList.push(item.Id);
      }
    },
    // 选择 - 施工方式
    choiceRange() {
      this.constructionMethod = true;
      this.tmpList = this.constructionList.map(item=>item.rangeId)
      var obj = {
        tableName: 'tBDBearRange',
        keyWord: this.searchCon,
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          this.specialtyStyleList = data.ResultObj;
        } else {
          this.specialtyStyleList = [];
        }
      });
    },
    // 确认 - 施工方式
    yesConstructionSure() {
      this.constructionMethod = false; // 隐藏弹框
      this.constructionList = this.constructionList.filter(item=>this.tmpList.indexOf(item.rangeId)>-1)
      this.tmpList.map(i =>{
        let item = this.specialtyStyleList.find(item=>item.Id==i)
        if(this.constructionList.find(ii=>ii.rangeId==item.Id)){}
        else{
          let newData = {
            rangeId: item.Id, // 施工方式id
            rangeName: item.Name, // 施工方式名称
            brandSpecialOfferCommissionRate: 10,
            brandOrdinaryCommissionRate: 20,
            platformRate: 2,
            userRate: 20,
            firstCoRate: 40,
            secondCoRate: 7,
            coRate: 1,
            partnerRate: 6,
            guideRate: 3,
            bdRate: 1,
            designerRate: 20,
          };
          this.constructionList.push(newData);
        }
      })
    },
    // 取消 - 施工方式
    noConstruction() {
      this.constructionMethod = false; // 取消弹框
    },
    // 公装数据
    choosework(item, index) {
      if (this.DomainIds.indexOf(item.Id) > -1) {
        this.homenamearr.splice(this.DomainIds.indexOf(item.Id), 1);
        this.DomainIds.splice(this.DomainIds.indexOf(item.Id), 1);
        this.$refs.work[index].style.color = "#606266";
        this.$refs.work[index].style.background = "#f0f0f0";
        if (this.homenamearr.length == 0) {
          this.isshowbrand = false;
        }
      } else {
        this.isshowbrand = true;
        this.homenamearr.push(item.Name);
        this.DomainIds.push(item.Id);
        this.$refs.work[index].style.color = "#fff";
        this.$refs.work[index].style.background = "#F56C6C";
      }
    },
    // 擅长空间 - 返回
    nosure2() {
      this.centerDialogVisible = false; // 擅长空间
      this.DomainIds = [];
      this.homenamearr = [];
      for (var i = 0; i < this.DomainIds1.length; i++) {
        this.homenamearr.push(this.homenamearr1[i]);
        this.DomainIds.push(this.DomainIds1[i]);
      }
    },
    // 擅长空间 - 确认
    yessure2() {
      this.centerDialogVisible = false; // 擅长空间
      this.DomainIds1 = JSON.parse(JSON.stringify(this.DomainIds));
      this.homenamearr1 = JSON.parse(JSON.stringify(this.homenamearr));
    },
    // 擅长空间 - 弹框
    choosehome(item, index) {
      if (this.DomainIds.indexOf(item.Id) > -1) {
        this.homenamearr.splice(this.DomainIds.indexOf(item.Id), 1);
        this.DomainIds.splice(this.DomainIds.indexOf(item.Id), 1);
        this.$refs.home[index].style.color = "#606266";
        this.$refs.home[index].style.background = "#f0f0f0";
        if (this.homenamearr.length == 0) {
          this.isshowbrand = false;
        }
      } else {
        this.isshowbrand = true;
        this.homenamearr.push(item.Name);
        this.DomainIds.push(item.Id);
        this.$refs.home[index].style.color = "#fff";
        this.$refs.home[index].style.background = "#F56C6C";
      }
    },
    // 选择 - 擅长空间
    choosekong() {
      this.centerDialogVisible = true; // 擅长空间
      this.homearr = [];
      this.workarr = [];
      var obj = {};
      SelectDesignerSkilledDoMainBaseData(obj).then(data => {
        if (data.ResultCode == 1) {
          for (var i = 0; i < data.ResultObj.length; i++) {
            if (data.ResultObj[i].DomainType == 0) {
              this.homearr.push(data.ResultObj[i]);
              this.$nextTick(() => {
                for (var i = 0; i < this.$refs.home.length; i++) {
                  this.$refs.home[i].style.color = "#606266";
                  this.$refs.home[i].style.background = "#f0f0f0";
                }
                for (var i = 0; i < this.homearr.length; i++) {
                  for (var k = 0; k < this.DomainIds.length; k++) {
                    if (this.homearr[i].Id == this.DomainIds[k]) {
                      //           this.$nextTick(() => {
                      this.$refs.home[i].style.color = "#fff";
                      this.$refs.home[i].style.background = "#F56C6C";
                      // })
                    }
                  }
                }
              });
            } else {
              this.workarr.push(data.ResultObj[i]);
              this.$nextTick(() => {
                for (var i = 0; i < this.$refs.work.length; i++) {
                  this.$refs.work[i].style.color = "#606266";
                  this.$refs.work[i].style.background = "#f0f0f0";
                }
                for (var i = 0; i < this.workarr.length; i++) {
                  for (var k = 0; k < this.DomainIds.length; k++) {
                    if (this.workarr[i].Id == this.DomainIds[k]) {
                      //           this.$nextTick(() => {
                      this.$refs.work[i].style.color = "#fff";
                      this.$refs.work[i].style.background = "#F56C6C";
                      // })
                    }
                  }
                }
              });
            }
          }
        }
      });
    },
    // 关闭弹框
    handleCloseDialog() {
      this.centerDialogVisible = false; // 擅长空间
      this.constructionMethod = false; // 施工方式
    },

    // 上传店铺Logo - 品牌建材
    brandBuildingMaterials(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          that.handleOss(1); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          that.ppjcLogo = newOssPic; // 品牌建材: 长链接
          that.ppjcUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 品牌建材: 短连接
        };
      }).catch(() => {
        this.$swal({
          type: "warning",
          text: "上传的图片必须是宽高比例为1:1",
        });
      });
    },
    // 上传店铺Logo - 装修公司
    decorationCompany(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          that.handleOss(37); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          that.zxgsLogo = newOssPic; // 装修公司: 长链接
          that.zxgsUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 装修公司: 短连接
        };
      }).catch(() => {
        this.$swal({
          type: "warning",
          text: "上传的图片必须是宽高比例为1:1",
        });
      });
    },
    
    // 展示图片
    beforeUploadShopIntroduction(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      isSize.then( () => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {
            type: 38
          };
          getOssFile(obj).then(data => {
            this.fileName = file.name;
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imgShopArr.push(newOssPic);
          that.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

          var obj = {
            name: this.fileName,
            url: that.imgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(obj).then(data => {
            if (data.resultCode == 1) {
              that.onePic.push(data.resultObj);
            }
          });
        };
        if (that.imgShopArr.length >= 4) {
          that.isdisabled = false;
        }
        that.cropping = false; // 图片裁剪弹框
      }, () => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            setTimeout(()=>{
              // document.querySelector('.crop-info').setHTML("1200 x 675")
              document.querySelector('.crop-info').innerHTML = '1200 x 675'
            },300)
          })
          return
        };
        // this.$swal({
        //   type: "warning",
        //   text: "上传图片宽高应为1200*675"
        // });
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=1200;
          canvas.height=675;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
          var file = dataURLtoFile(getRes)
          that.beforeUploadShopIntroduction(file)
        }
      })
    },
    // 展示图片-del
    deleteimg(index) {
      this.imgShopArr.splice(index, 1);
      this.onePic.splice(index, 1);
      if (this.imgShopArr.length >= 5) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
    },
    // 店铺服务图片
    beforeAvatarUpload(file,index) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.$swal({
          type:"warning",
          text:"上传图片格式应为jpg/png"
        })
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 200;
        let height = 200;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          that.handleOss(28); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          // let newOssPic = "https://taozhuanr.oss-cn-beijing.aliyuncs.com/Resource/RegionOfflineActive/NpKBSd_src=http___www.soumeitu.com_wp-content_uploads_2020_07_5f16a9063ffd3.jpg&refer=http___www.soumeitu.jpg";
          var obj = {
            name: "",
            imageUrl: newOssPic,
            isOpen: 0,
            isBuiltIn: 0
          };
          if(index == 1){
            that.services.push(obj);
            if(that.services.length >= 9){
              that.services_isdisabled = false;
            }
          }else if(index == 2){
            that.maServices.push(obj);
            if(that.maServices.length >= 9){
              that.maServices_isdisabled = false;
            }
          }
        };
      }).catch(() => {
        this.$swal({
          type:"warning",
          text:"上传图片宽高应为200*200"
        })
        return Promise.reject();
      });
    },
    // 删除店铺服务店铺图片
    deleteServicesImg(index) {
      this.services.splice(index, 1);
      if (this.services.length >= 9) {
        this.services_isdisabled = false;
      }else{
        this.services_isdisabled = true;
      }
    },
    // 删除店铺服务店铺图片
    deleteMaServicesImg(index) {
      this.maServices.splice(index, 1);
      if (this.maServices.length >= 9) {
        this.maServices_isdisabled = false;
      }else{
        this.maServices_isdisabled = true;
      }
    },
    // 视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.$swal({
          type:"warning",
          text:"请上传小于50MB的视频"
        })
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.$swal({
          type:"warning",
          text:"请上传mp4格式的视频"
        })
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      // this.videoUploadPercent = Math.floor(file.percentage)
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      // 上传视频获取路径
      uploadVedio(obj2, 2).then(data=>{
        if(data.resultCode == 1){
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8; // 视频全路径
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'') // 切割
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      });
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
          // videoUrl.sources[0].src = ''
          // videoUrl.poster = ''
        }
      }).catch(() => {
        return;
      });
    },
    // 返回
    goOneback() {
      this.$router.go(-1);
    },
    // 装修公司服务标识
    zxgsfwbs() {
      newGetDcService('obj').then(data => {
        if (data.resultCode == 1) {
          this.newActivityFormList = data.resultObj;
        } else {
          this.newActivityFormList = [];
        }
      });
    },
    // 主营业务
    zhuyingyewu() {
      var obj = {
        tableName: 'tBDBearRange',
        keyWord: this.searchCon,
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          this.checkList = data.ResultObj;
        } else {
          this.checkList = [];
        }
      });
    },
    /* oss 直传图片 */
    handleOss(val){
      let obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    init(){},

  },
  created() {
    this.addOredit = this.$route.query.type; // 新增 or 编辑 标识
    this.newBbType = this.$route.query.storeType; // 类型
    this.zxgsfwbs(); // 装修公司服务标识
    this.zhuyingyewu(); // 主营业务
    this.getProvincialAndUrbanAreas(); // 获取省市区
    
    this.getsgfs(); // 施工方式
    if (this.$route.query.type == 0) { // 添加店铺
      // 清空数据
      this.ppjc = false;
      this.zxgs = false;
    }
    if (this.$route.query.type == 1) { // 编辑店铺
      this.newBbType = this.$route.query.storeType; // 店铺类型
      if(this.newBbType == 1) {
        this.ppjc = false;
        this.zxgs = true;
      }
      if (this.newBbType == 2) {
        this.ppjc = true;
        this.zxgs = false;
      }
      this.getEchoInfo(); // 回显 品牌建材 & 装修公司
    }
    
  },
};
</script>

<style>
.labletop .el-form-item__label {
  margin-top: 57px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>

<style scoped lang="less">
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.spanimg {
  width: 100%;
  height: 100%;
}
.red {
  width: 80px;
  height: 100px;
  color: #F56C6C;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 600;
}
.redspan {
  background: #F56C6C;
  width: 130px;
  height: 2px;
  display: block;
  position: absolute;
  top: 40px;
  left: -23px;
}
.nored {
  width: 80px;
  height: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 500;
}
.spanflex {
  display: flex;
  justify-content: space-between;
}
.choice {
  cursor: pointer;
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice1 {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: not-allowed;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}
.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}
// 店铺logo
.avatar-uploader-dpLogo .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-dpLogo .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-dpLogo{
  height: 80px;
}
.avatar-dpLogo {
  width: 80px;
  height: 80px;
  display: block;
}
.avatar-uploader-dpLogo .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
}
// 展示图片
.avatar-uploader-zstp .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-zstp {
  width: 100px;
  height: 50px;
  display: block;
}
.avatar-uploader-zstp .avatar-uploader-icon {
  width: 80px;
  line-height: 80px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #eeeeee;
}
.chooseDia {
  width: 740px;
  height: 360px;
  background: #fff;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;
  .searchRight {
    width: 100%;
    height: 360px;
    overflow: hidden;
    text-align: left;
    .searchTop {
      padding: 20px 20px 15px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      span {
        display: inline-block;
        cursor: pointer;
        margin: 0 20px 10px 10px;
      }
      /deep/ .el-input {
        width: 240px;
        height: 35px;
        background: #fff;
        margin-top: -10px;
        float: right;
        .el-input__inner {
          height: 35px;
          border: 1px solid #ededed;
        }
      }
      p {
        margin-top: 20px;
        /deep/ .el-input {
          float: none;
          width: 180px;
          height: 35px;
        }
      }
    }
    .searchBot {
      box-sizing: border-box;
      padding: 0 20px;
      overflow-y: scroll;
      p {
        display: inline-block;
        float: left;
        padding: 8px;
        background: #f0f0f0;
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}
.changeColor {
  color: #F56C6C;
  cursor: pointer;
}
.brandColor {
  background: #F56C6C !important;
  color: #fff !important;
}
// 店铺管理员
.administrators {
  width: 90%;
  font-size: 17px;
  padding: 10px 0;
}
.administrators span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 10px;
}
// 主营品牌
.mainBrand {
  display: flex;
  width: 80%;
  margin-top: 10px;
}
.brandTable {
  width: 60px;
  margin: 5px 0;
}

// ********************************************************

.choice {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
/* 免预约 & 需预约 */
.myyxyy {
  width: 80%;
  line-height: 40px;
  border-bottom: 2px solid #eee;
}
/* 预约服务 */
.yyfwClass {
  width: 360px;
  height: 58px;
  line-height: 55px;
  border: 1px solid #eee;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.yyfwImg {
  width: 50px !important;
  height: 50px !important;
  margin: 5px 0;
  border-radius: 3px;
}
.yyfwInput {
  border-right: 1px solid #eee;
  padding-right: 30px;
}
/* 上传icon */
.yyfwIcon {
  width: 360px;
  line-height: 50px;
  border: 1px solid #eeeeee;
  font-size: 25px;
  color: #8c939d;
  text-align: center;
}
/* 穿梭框 */
.shuttle {
  border: 1px solid #eee;
}

.TLeft {
  width: 49%;
  float: left;
  height: 220px;
  overflow-y: auto;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 40px;
  box-sizing: border-box;
}

.TLeft p {
  /* margin-left: 20px; */
  color: #000;
  font-size: 12px;
  width: 90%;
}

/* 选择框 */
.TLeft .left_img {
  width: 16px;
  height: 16px;
  z-index: 999;
  margin-bottom: 6px;
  cursor: pointer;
}

.border_r {
  border-left: 1px solid #eee;
  height: 220px;
  overflow-y: auto;
  padding-left: 20px;
  padding-bottom: 20px;
}

.TRight {
  position: relative;
  width: 68%;
  /* height: 50px; */
  /* display: inline-block; */
}

.TRight p {
  background: #f2f2f2;
  text-align: center;
  /* margin-top: 18px; */
  margin-left: 13px;
  padding: 5px 15px;
}

.TRight img {
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
}

/* 角色列表 */
.shut p {
  border-right: 1px solid #eee;
  height: 50px;
  background: #bbb;
  line-height: 50px;
  padding-left: 20px;
  font-size: 12px;
  color: #000;
  opacity: 0.49;
  margin: 15px 0 0 0;
}
</style>


// WEBPACK FOOTER //
// seeFindshop.vue?4c81ab00